import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@material-ui/core';
import { IRainMeterMeasurementFormValues } from '../../../../@types/model/rainMeter/rainMeterMeasurement/rainMeterMeasurementFormValues';
import RainMeterMeasurementModelHelper from '../../../../@types/model/rainMeter/rainMeterMeasurement/rainMeterMeasurementModelHelper';
import CustomControlledTextField from '../../../customComponentV2/input/CustomControlledTextField';
import CustomLabelledCheckBox from '../../../customComponentV2/input/CustomCheckBox';

interface IRainMeterMeasurementEditFormProps {
    initialValues : IRainMeterMeasurementFormValues;
    onSubmit : (values : IRainMeterMeasurementFormValues) => void;
    onCancel : () => void;
}

const RainMeterMeasurementEditForm = (props : IRainMeterMeasurementEditFormProps) : React.ReactElement => {
    const schema = RainMeterMeasurementModelHelper.formSchema();

    const { handleSubmit, control, formState: { isValid } } = useForm<IRainMeterMeasurementFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30 pt15 pb0'}>
                    <div className={'fdc wfill pt10 jcc aic mb20'}>
                        <div className={'wfill mb15'}>
                            <CustomControlledTextField 
                                className={'wfill'}
                                label={'Measurement (mm)'}
                                name={'value'}
                                control={control}
                            />
                        </div>
                    </div>
                    <div className='flx1 fdr jcfs'>
                        <CustomLabelledCheckBox 
                            name={'isActive'}
                            label={'Is Active'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe mb20'}>
                        <div className={'jcfe'}>
                            <Button className='m10' disabled={!isValid} type='submit' variant='contained' color='primary'>
                                OK
                            </Button>
                            <Button className='m10' variant='outlined' onClick={props.onCancel} color='primary' autoFocus>
                                CANCEL
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default RainMeterMeasurementEditForm;